import React, { useRef } from 'react'

import { InlineIcon } from '@iconify/react';
import arrowDownSLine from '@iconify/icons-ri/arrow-down-s-line';

import CareerPlaceCard from './careerplacecard'

export default (props) => {

  const accordionsRefs = useRef([])
  accordionsRefs.current = []

  const addToRefs = (el) => {
    if (el && !accordionsRefs.current.includes(el))
    accordionsRefs.current.push(el)
  }

  const toggleAccordion = (e) => {
    const accordionTarget = e.target.closest('.accordion')

    if (accordionTarget.classList.contains('is-active'))
      return

    accordionsRefs.current
      .forEach((accordion) => accordion.classList.remove('is-active'))
    accordionTarget.classList.add('is-active')
  }

  return (
    <div className="career__box box">
      {props.data.map((thisPlace, index) =>
        <div
          key={thisPlace.key}
          ref={addToRefs}
          className={"dropdown accordion" + (!index ? ' is-active' : '')}>
          <div className="dropdown-trigger accordion__dropdownTrigger">
            <button
              className="accordion__button is-link-button title is-4"
              onClick={(e) => toggleAccordion(e)}>
              <div className="accordion__title">
                <span>{thisPlace.title}</span>
                <InlineIcon icon={arrowDownSLine} />
              </div>
              <div className="accordion__placeVisualCue"></div>
            </button>
          </div>        
          <div className="dropdown-menu accordion__dropdownMenu">
            <div className="dropdown-content accordion__dropdownContent">
              <CareerPlaceCard currentPlace={thisPlace} />
            </div>
          </div>
        </div>
      )}
    </div>
  )
}
